import React from 'react';
import { Outlet } from 'react-router-dom';

export default function StormwaterProject({ siteData, children }) {

    let projectComponent;
    if (siteData.site) {
        let address =
            siteData.site.street &&
            siteData.site.city &&
            siteData.site.state &&
            siteData.site.zip &&
            `${siteData.site.street}, ${siteData.site.city}, ${siteData.site.state} ${siteData.site.zip}`;

        let county = siteData.site.county && `${siteData.site.county} County`;

        let latlong;
        if (siteData.site.latitude && siteData.site.longitude) {
            let lat = siteData.site.latitude && (<div className="latlongValue" onClick={() => window.open(latlongUrl, '_blank')}>
                <span className="label">Lat:</span>{siteData.site.latitude < 0 ? "" : "\u00A0"}{siteData.site.latitude}
            </div>);
            let long = siteData.site.longitude && (<div className="latlongValue" onClick={() => window.open(latlongUrl, '_blank')}>
                <span className="label">Long:</span>{siteData.site.longitude < 0 ? "" : "\u00A0"}{siteData.site.longitude}
            </div>);
            let latlongUrl = `https://www.bing.com/maps?q=${siteData.site.latitude},${siteData.site.longitude}`;
            latlong =
                (<div className="latlongContainer">
                    <div className="latlongIconContainer">
                        <i className="icon dhicon-location-2" onClick={() => window.open(latlongUrl, '_blank')}></i>
                    </div>
                    <div className="latlong">{lat}{long}</div>
                </div>);
        }

        // https://www.google.com/maps/@?api=1&map_action=map&center=41.621544,-93.445419

        projectComponent = siteData.site && (<div className="siteHeaderContainer">
            <div className="siteHeaderIcon">
                <i className="icon dhicon-site2" />
            </div>
            <div className="siteHeaderInfo">
                <div className="siteHeader">
                    <div className="projectName">{siteData.site.siteName}</div>
                    <div>{address}</div>
                    <div>{county}</div>
                </div>
                {latlong}
            </div>
        </div>);
    }
    return (<div className="stormwaterContainer">
        <div className="stormwater">
            {projectComponent}
            {children}
        </div>
    </div>);
}